import { ReactNode, useState } from "react";

interface TabsProps {
    headers: string[];
    tabs: Record<string, ReactNode>;
    activeTab: string,
    setActiveTab: React.Dispatch<React.SetStateAction<string>>,
}

const Tabs = ({ headers, tabs, activeTab, setActiveTab }: TabsProps) => {

    return (
        <div className="tabs-container">
            {/* TAB HEADERS */}
            <div className="tab-headers">
                {headers.map((tab) => (
                    <div
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`tab-header ${activeTab === tab ? "active-tab" : ""}`}
                    >
                        {tab}
                    </div>
                ))}
            </div>

            {/* TAB CONTENT */}
            <div className="tab-content">
                {tabs[activeTab]}
            </div>
        </div>
    );
};

export default Tabs;
